import type { LaunchpadContextPayload } from '@/hooks/useLaunchpadContext'

export const LAUNCHPAD_CONTEXT_EVENT = 'hubee:launchpad-context-change'

export function publishLaunchpadContext(context: LaunchpadContextPayload | null) {
  if (typeof window === 'undefined') return

  window.dispatchEvent(
    new CustomEvent(LAUNCHPAD_CONTEXT_EVENT, {
      detail: {
        context,
      },
    })
  )
}

export function subscribeLaunchpadContext(
  callback: (context: LaunchpadContextPayload | null) => void
) {
  if (typeof window === 'undefined') {
    return () => {}
  }

  function handler(event: Event) {
    const customEvent = event as CustomEvent<{
      context?: LaunchpadContextPayload | null
    }>

    callback(customEvent.detail?.context || null)
  }

  window.addEventListener(LAUNCHPAD_CONTEXT_EVENT, handler)

  return () => {
    window.removeEventListener(LAUNCHPAD_CONTEXT_EVENT, handler)
  }
}